import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root',
})

export class FlashService {
  
  constructor(private _snackBar: MatSnackBar) {
    
  }

  /**
   * @description method to open snakbar based on params 
   * @param message The message to show in the snackbar.
   * @param action The label for the snackbar action.
   * @param type The type of snackbar, basically colour 
   * @param duration The length of time in milliseconds to wait before automatically dismissing the snack bar.
   */
  openSnackBar(message: string, action: string, type: string = "Success-ew-message", duration = 2000) {
    
    this._snackBar.open(message, action, {
      duration: duration,
      //panelClass:'Success-ew-message'
      //panelClass:'error-ew-message'
      panelClass:type
    });
  }

  /**
   * @description Closes currently visible snack bar.
   */
  closeSnackBar() { 
    this._snackBar.dismiss();
  }

}
